// File attachment helpers
const MAX_FILE_SIZE = 8 * 1024 * 1024; // 8 MB
const ACCEPTED = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/jpg': '.jpg',
  'image/webp': '.webp',
  'image/gif': '.gif',
  'application/pdf': '.pdf',
  'text/plain': '.txt',
  'text/markdown': '.md',
  'text/csv': '.csv',
};

export const isAcceptedMime = (mime) => Object.prototype.hasOwnProperty.call(ACCEPTED, mime || '');

export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(reader.error || new Error('FileReader failed'));
  reader.onload = () => {
    const result = reader.result;
    if (typeof result !== 'string') return reject(new Error('Unexpected reader result'));
    // result = "data:image/png;base64,XXXX"
    const idx = result.indexOf(',');
    resolve(idx >= 0 ? result.slice(idx + 1) : result);
  };
  reader.readAsDataURL(file);
});

export const validateFile = (file) => {
  if (!file) return { ok: false, error: 'Aucun fichier' };
  if (file.size > MAX_FILE_SIZE) return { ok: false, error: `Fichier trop volumineux (max ${MAX_FILE_SIZE / 1024 / 1024} MB)` };
  if (!isAcceptedMime(file.type)) return { ok: false, error: `Type non supporté : ${file.type || 'inconnu'}` };
  return { ok: true };
};

export const ACCEPT_ATTR = Object.keys(ACCEPTED).join(',');

export const humanSize = (bytes) => {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / 1024 / 1024).toFixed(2)} Mo`;
};
